import * as actionTypes from 'constants/ActionTypes';

export function getBackendNotifications() {
    return {
        type: actionTypes.GET_BACKEND_NOTIFICATIONS.REQUEST,
    };
}

export function getBackendNotification(id) {
    return {
        type: actionTypes.GET_BACKEND_NOTIFICATION.REQUEST,
        data: id,
    };
}

export function deleteBackendNotification(id) {
    return {
        type: actionTypes.DELETE_BACKEND_NOTIFICATION.REQUEST,
        id,
    };
}

export function updateBackendNotification(data) {
    return {
        type: actionTypes.UPDATE_BACKEND_NOTIFICATION.REQUEST,
        data,
    };
}

export function createBackendNotification(data) {
    return {
        type: actionTypes.UPDATE_BACKEND_NOTIFICATION.REQUEST,
        data,
    };
}




// WEBPACK FOOTER //
// ./app/actions/notifications/backendNotifications.js